import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export const CiscoNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="cisco" />;
};
